import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
    HiOutlineHome,
    HiOutlineBriefcase,
    HiOutlineChatAlt2,
    HiOutlineCog,
    HiOutlineBell,
    HiOutlineUserCircle,
    HiOutlineLink,
    HiOutlineArrowUp,
    HiX
} from "react-icons/hi";

const CreatorSettings = () => {
    // Determine which settings tab is active. Default to 'account'
    const [activeTab, setActiveTab] = useState("account");

    // Modal State
    const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
    const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);

    // Form State for Modals
    const [emailPasswordInput, setEmailPasswordInput] = useState("");
    const [newEmailInput, setNewEmailInput] = useState("");
    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    return (
        <div className="flex h-screen bg-[#FDFBF7] overflow-hidden">
            {/* Main Creator Sidebar */}
            <Sidebar />

            <main className="flex-1 flex flex-col min-w-0">
                {/* Top Header */}
                <header className="px-8 py-4 flex justify-end items-center shrink-0">
                    <div className="flex items-center gap-6">
                        <button className="relative text-gray-500 hover:text-gray-700">
                            <HiOutlineBell className="text-2xl" />
                        </button>
                        <Link to="/creator/public-profile" className="flex items-center gap-3 hover:opacity-80 transition-opacity">
                            <span className="text-sm font-bold text-gray-800">Johan Doe</span>
                            <div className="w-10 h-10 rounded-full bg-[#0044CC] flex items-center justify-center text-white font-bold shadow-md hover:ring-2 hover:ring-blue-300 transition-all">
                                J
                            </div>
                        </Link>
                    </div>
                </header>

                {/* Inner Content Area */}
                <div className="flex-1 px-8 pb-6 max-w-7xl mx-auto w-full h-[calc(100vh-80px)]">
                    
                    <div className="flex bg-white rounded-3xl shadow-sm border border-gray-100 h-full overflow-hidden">
                        {/* Inner Sub-Navigation */}
                        <aside className="w-[280px] shrink-0 bg-[#F4F7FB] py-8 px-6 flex flex-col">
                            {/* Profile Header Block */}
                        <div className="mb-6">
                            <h2 className="text-sm font-bold text-gray-900 mb-6">Account</h2>
                            <div className="flex items-center gap-4">
                                <img src="https://i.pravatar.cc/150?u=kamran" alt="Profile" className="w-12 h-12 rounded-full object-cover shadow-sm" />
                                <div>
                                    <p className="text-sm font-bold text-gray-900 leading-tight">kamran Razvi</p>
                                    <p className="text-xs text-gray-500 mt-1">Kamran5kr7@gmail.com</p>
                                </div>
                            </div>
                        </div>

                        {/* Navigation Links */}
                        <nav className="space-y-2">
                            <button 
                                onClick={() => setActiveTab("account")}
                                className={`w-full flex items-center gap-3 px-4 py-3.5 rounded-2xl text-sm transition-colors
                                    ${activeTab === "account" ? 'bg-white text-[#0044CC] font-bold shadow-sm' : 'text-gray-600 hover:bg-white/50 font-medium'}
                                `}
                            >
                                <span className="text-xl">
                                    <HiOutlineUserCircle className={activeTab === "account" ? "text-[#0044CC]" : "text-gray-400"} />
                                </span>
                                My account
                            </button>
                            <button 
                                onClick={() => setActiveTab("linked")}
                                className={`w-full flex items-center gap-3 px-4 py-3.5 rounded-2xl text-sm transition-colors
                                    ${activeTab === "linked" ? 'bg-white text-[#0044CC] font-bold shadow-sm' : 'text-gray-600 hover:bg-white/50 font-medium'}
                                `}
                            >
                                <span className="text-xl">
                                    <HiOutlineLink className={activeTab === "linked" ? "text-[#0044CC]" : "text-gray-400"} />
                                </span>
                                Linked accounts
                            </button>
                            <button 
                                onClick={() => setActiveTab("upgrade")}
                                className={`w-full flex items-center gap-3 px-4 py-3.5 rounded-2xl text-sm transition-colors
                                    ${activeTab === "upgrade" ? 'bg-white text-[#0044CC] font-bold shadow-sm' : 'text-gray-600 hover:bg-white/50 font-medium'}
                                `}
                            >
                                <span className="text-xl">
                                    <HiOutlineArrowUp className={activeTab === "upgrade" ? "text-[#0044CC]" : "text-gray-400"} />
                                </span>
                                Upgrade Plan
                            </button>
                        </nav>
                        </aside>

                        {/* Tab Content Area */}
                        <div className="flex-1 p-8 mt-2 h-full overflow-y-auto overflow-x-hidden">
                            {activeTab === "account" && <MyAccountView onEmailClick={() => setIsEmailModalOpen(true)} onPasswordClick={() => setIsPasswordModalOpen(true)} />}
                            {activeTab === "linked" && <LinkedAccountsView />}
                            {activeTab === "upgrade" && <UpgradePlanView />}
                        </div>
                    </div>

                </div>
            </main>

            {/* Modals Rendering */}
            <ChangeEmailModal 
                isOpen={isEmailModalOpen} 
                onClose={() => setIsEmailModalOpen(false)} 
                password={emailPasswordInput}
                setPassword={setEmailPasswordInput}
                newEmail={newEmailInput}
                setNewEmail={setNewEmailInput}
            />
            
            <ChangePasswordModal 
                isOpen={isPasswordModalOpen} 
                onClose={() => setIsPasswordModalOpen(false)}
                currentPassword={currentPassword}
                setCurrentPassword={setCurrentPassword}
                newPassword={newPassword}
                setNewPassword={setNewPassword}
                confirmPassword={confirmPassword}
                setConfirmPassword={setConfirmPassword}
            />

        </div>
    );
};

// --- View Components ---

const MyAccountView = ({ onEmailClick, onPasswordClick }) => (
    <div className="w-full space-y-6">
        <h2 className="text-xl font-bold text-gray-900 mb-4">My profile</h2>
        
        {/* Profile Edit Section */}
        <div className="flex items-start gap-10">
            <div className="w-[80px] h-[80px] rounded-full overflow-hidden shrink-0 mt-1">
                <img src="https://i.pravatar.cc/150?u=kamran" alt="Profile" className="w-full h-full object-cover" />
            </div>
            <div className="flex-1 space-y-4 max-w-2xl">
                <div>
                    <label className="block text-xs font-bold text-gray-500 mb-1">Preferred name</label>
                    <input 
                        type="text" 
                        defaultValue="Kamran Razvi" 
                        className="w-full bg-[#F4F7FB] border-none rounded-xl px-4 py-2.5 text-sm font-bold text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-100"
                    />
                </div>
                <div>
                    <label className="block text-xs font-bold text-gray-500 mb-1">Preferred username</label>
                    <input 
                        type="text" 
                        defaultValue="Kamranrazvii" 
                        className="w-full bg-[#F4F7FB] border-none rounded-xl px-4 py-2.5 text-sm font-bold text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-100"
                    />
                </div>
            </div>
        </div>

        {/* Security Section */}
        <div className="pt-6 border-t border-gray-100">
            <h3 className="text-xl font-bold text-gray-900 mb-6">Account Security</h3>
            
            <div className="space-y-6 max-w-3xl">
                <div className="flex items-center justify-between pb-6 border-b border-gray-50">
                    <div>
                        <p className="font-bold text-sm text-gray-900">Email</p>
                        <p className="text-sm text-gray-500 mt-1">Kamran5kr7@gmail.com</p>
                    </div>
                    <button 
                        onClick={onEmailClick}
                        className="px-6 py-2.5 bg-white border border-gray-200 rounded-xl text-sm font-bold text-gray-800 hover:bg-gray-50 transition-colors shadow-sm"
                    >
                        Change email
                    </button>
                </div>

                <div className="flex items-start justify-between">
                    <div>
                        <p className="font-bold text-sm text-gray-900">Password</p>
                        <p className="text-sm text-gray-500 mt-1 max-w-sm leading-relaxed">Set a permanent password to login to your account</p>
                    </div>
                    <div className="flex flex-col items-end gap-2">
                        <button 
                            onClick={onPasswordClick}
                            className="px-6 py-2.5 bg-white border border-gray-200 rounded-xl text-sm font-bold text-gray-800 hover:bg-gray-50 transition-colors shadow-sm w-full"
                        >
                            Change password
                        </button>
                        <button className="px-6 py-2 bg-white border border-red-200 text-red-500 rounded-xl text-xs font-bold shadow-sm hover:bg-red-50 transition-colors mt-1 w-full">
                            Logout
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
);

const LinkedAccountsView = () => {
    const platforms = [
        { name: "Youtube", icon: "fa-brands fa-youtube text-red-500" },
        { name: "Tiktok", icon: "fa-brands fa-tiktok text-black" },
        { name: "Facebook", icon: "fa-brands fa-facebook text-blue-600" },
        { name: "X", icon: "fa-brands fa-x-twitter text-black" },
        { name: "Snapchat", icon: "fa-brands fa-snapchat text-yellow-400" },
        { name: "Linkedin", icon: "fa-brands fa-linkedin text-blue-700" },
        { name: "Twitch", icon: "fa-brands fa-twitch text-purple-600" },
    ];

    return (
        <div className="h-full">
            <h2 className="text-lg font-bold text-gray-900 mb-4">Link Accounts</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {platforms.map((platform) => (
                    <div key={platform.name} className="bg-white border border-gray-100 rounded-2xl p-4 flex flex-col justify-between h-[160px] hover:shadow-md transition-shadow">
                        <div>
                            <i className={`${platform.icon} text-xl mb-2`}></i>
                            <h3 className="font-bold text-sm text-gray-900 mb-1">{platform.name}</h3>
                            <p className="text-xs text-gray-400 leading-relaxed text-ellipsis overflow-hidden line-clamp-2">Lorem ipsum dolor sit amet, consectetur adipiscing vel facilisis.</p>
                        </div>
                        <button className="w-full py-1.5 bg-white border border-gray-200 rounded-lg text-sm font-bold text-[#0044CC] hover:bg-gray-50 transition-colors shadow-sm mt-2">
                            Connect
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
};

const UpgradePlanView = () => (
    <div className="space-y-6 max-w-4xl mx-auto">
        <div>
            <h2 className="text-lg font-bold text-gray-900 mb-4">Active plan</h2>
            <div className="flex justify-between items-start">
                <div>
                    <h3 className="font-bold text-gray-900 mb-1">Free</h3>
                    <p className="text-sm text-gray-500">Lorem ipsum dolor sit amet, consectetur adipiscing vel facilisis.</p>
                    <p className="text-sm text-gray-400 mt-1">$0 per / month</p>
                </div>
            </div>
        </div>

        <div>
            <h2 className="text-xl font-bold text-gray-900 mb-6 pt-6 border-t border-gray-100">All Plans</h2>
            <div className="flex flex-wrap gap-12 lg:gap-20">
                {/* Free Plan */}
                <div className="space-y-4 w-[180px]">
                    <h3 className="font-bold text-gray-900 text-base">Free</h3>
                    <p className="text-sm font-bold text-gray-900">$0 per / month</p>
                </div>

                {/* Plus Plan */}
                <div className="space-y-4 w-[180px]">
                    <div className="flex items-center gap-3">
                        <h3 className="font-bold text-gray-900 text-base">Plus</h3>
                        <span className="text-[10px] font-bold text-[#0044CC] bg-blue-50 px-2.5 py-1 rounded-md">Popular</span>
                    </div>
                    <div className="space-y-1">
                        <p className="text-sm font-bold text-gray-900">$10 per / month</p>
                        <p className="text-xs text-gray-600 font-bold">billed annualy</p>
                        <p className="text-xs text-gray-400">$12 billed monthly</p>
                    </div>
                    <button className="w-[140px] py-2 bg-[#0044CC] text-white rounded-lg text-sm font-bold shadow-sm hover:bg-blue-700 transition-colors">
                        Upgrade
                    </button>
                </div>

                {/* Premium Plan */}
                <div className="space-y-4 w-[180px]">
                    <h3 className="font-bold text-gray-900 text-base">Premium</h3>
                    <div className="space-y-1">
                        <p className="text-sm font-bold text-gray-900">$15 per / month</p>
                        <p className="text-xs text-gray-600 font-bold">billed annualy</p>
                        <p className="text-xs text-gray-400">$18 billed monthly</p>
                    </div>
                    <button className="w-[140px] py-2 bg-white border border-gray-200 text-[#0044CC] rounded-lg text-sm font-bold shadow-sm hover:bg-gray-50 transition-colors">
                        Upgrade
                    </button>
                </div>
            </div>
        </div>
    </div>
);

// --- Modal Components ---

const ChangeEmailModal = ({ isOpen, onClose, password, setPassword, newEmail, setNewEmail }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
            {/* Backdrop */}
            <div className="absolute inset-0 bg-black/20 backdrop-blur-sm" onClick={onClose}></div>
            
            {/* Modal Box */}
            <div className="relative bg-white rounded-[2rem] p-8 w-[480px] shadow-2xl z-10">
                <p className="text-sm text-gray-600 mb-6">
                    Your current email is <span className="font-bold text-gray-900">kamran5kr7@gmail.com</span><br/>
                    Please enter your password.
                </p>
                
                <input 
                    type="password" 
                    placeholder="Please enter your password." 
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="w-full bg-white border border-gray-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-[#0044CC] mb-6 shadow-sm"
                />

                <p className="text-sm text-gray-600 mb-4">
                    Please enter a new email and we will send you a verfication code
                </p>

                <input 
                    type="email" 
                    placeholder="Enter new email" 
                    value={newEmail}
                    onChange={(e) => setNewEmail(e.target.value)}
                    className="w-full bg-white border border-gray-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-[#0044CC] mb-6 shadow-sm"
                />

                <button className="w-full py-3.5 bg-[#0044CC] text-white rounded-xl text-sm font-bold shadow-md hover:bg-blue-700 transition-colors">
                    Send verfication code
                </button>
            </div>
        </div>
    );
};

const ChangePasswordModal = ({ isOpen, onClose, currentPassword, setCurrentPassword, newPassword, setNewPassword, confirmPassword, setConfirmPassword }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
             {/* Backdrop */}
             <div className="absolute inset-0 bg-black/20 backdrop-blur-sm" onClick={onClose}></div>
            
            {/* Modal Box */}
            <div className="relative bg-[#FDFDFD] rounded-[2rem] p-8 w-[500px] shadow-2xl z-10 border border-gray-100">
                
                {/* Close Button & Header */}
                <div className="flex justify-between items-start mb-6 -mt-2 -mr-2">
                    <div className="flex-1 flex flex-col items-center mt-2">
                        <div className="w-8 h-6 border-2 border-gray-900 rounded flex justify-center items-center mb-3">
                            <div className="w-1 h-1 bg-gray-900 rounded-full mx-0.5" />
                            <div className="w-1 h-1 bg-gray-900 rounded-full mx-0.5" />
                            <div className="w-1 h-1 bg-gray-900 rounded-full mx-0.5" />
                            <div className="w-1 h-1 bg-gray-900 rounded-full mx-0.5" />
                        </div>
                        <h2 className="text-base font-bold text-gray-900">Change password</h2>
                        <p className="text-xs text-gray-500 mt-2 text-center max-w-[280px]">
                            Use a password at least 15 letter long or at least 8 characters long with both letters and number
                        </p>
                    </div>
                    <button onClick={onClose} className="w-8 h-8 bg-[#0044CC] rounded-full flex items-center justify-center text-white hover:bg-blue-700 transition-colors">
                        <HiX className="text-sm" />
                    </button>
                </div>

                {/* Form Fields */}
                <div className="space-y-5">
                    <div>
                        <label className="block text-xs font-medium text-gray-600 mb-2">Enter your current password</label>
                        <input 
                            type="password" 
                            placeholder="Current password" 
                            value={currentPassword}
                            onChange={(e) => setCurrentPassword(e.target.value)}
                            className="w-full bg-white border border-gray-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-[#0044CC] shadow-sm"
                        />
                    </div>
                    
                    <div>
                        <label className="block text-xs font-medium text-gray-600 mb-2">Enter a new password</label>
                        <input 
                            type="password" 
                            placeholder="New password" 
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            className="w-full bg-white border border-gray-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-[#0044CC] shadow-sm"
                        />
                    </div>

                    <div>
                        <label className="block text-xs font-medium text-gray-600 mb-2">Confirm your new password</label>
                        <input 
                            type="password" 
                            placeholder="Confirm password" 
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            className="w-full bg-white border border-gray-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-[#0044CC] shadow-sm"
                        />
                    </div>
                </div>

                <div className="mt-8">
                    <button className="w-full py-3.5 bg-[#0044CC] text-white rounded-xl text-sm font-bold shadow-md hover:bg-blue-700 transition-colors h-[48px]">
                        Change password
                    </button>
                </div>
            </div>
        </div>
    );
};


// Extracted Sidebar to reuse identically
const Sidebar = () => {
    const location = useLocation();
    const isActive = (path) => location.pathname === path || location.pathname.startsWith(path + '/');

    return (
        <aside className="w-64 bg-white border-r border-gray-100 flex flex-col hidden md:flex shrink-0 z-20">
            <div className="p-6 flex items-center gap-2 text-black font-bold text-xl">
                <img src="/logo.png" alt="Braccet" className="w-8 h-8 object-contain" />
                <span>Braccet</span>
            </div>

            <nav className="flex-1 px-4 py-6 space-y-2">
                <SidebarItem icon={<HiOutlineHome />} label="Dashboard" to="/creator/dashboard" />
                <SidebarItem icon={<HiOutlineBriefcase />} label="Campaigns" to="/creator/find-work" />
                <SidebarItem icon={<span className="font-bold text-lg">(B)</span>} label="Brands" to="/creator/brands" />
                <SidebarItem icon={<HiOutlineChatAlt2 />} label="Messages" to="/creator/messages" />
                <SidebarItem icon={<HiOutlineCog />} label="Settings" to="/creator/profile" active={isActive('/creator/profile') || isActive('/creator/settings')} />
            </nav>

            <div className="p-4 border-t border-gray-100">
                <button className="flex w-full items-center gap-3 p-2 rounded-xl text-gray-500 font-bold hover:bg-gray-50 hover:text-red-500 transition-colors">
                    <svg className="w-6 h-6 rotate-180" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" /></svg>
                    Logout
                </button>
            </div>
        </aside>
    );
};

const SidebarItem = ({ icon, label, to, active }) => (
    <Link to={to} className={`flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium transition-colors ${active ? 'bg-blue-50 text-[#0044CC]' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'}`}>
        <span className="text-xl">{icon}</span>
        {label}
    </Link>
);

export default CreatorSettings;
